/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerUpLeft = createReactComponent("outline", "corner-up-left", "IconCornerUpLeft", [["path", { "d": "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4", "key": "svg-0" }]]);

export { IconCornerUpLeft as default };
//# sourceMappingURL=IconCornerUpLeft.mjs.map
